import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Slide } from '@mui/material';
import Dialog from '@mui/material/Dialog';

const SheetTransition = React.forwardRef(function SheetTransition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

function IntentPaymentStatusDialog({ open, title, description, onCancelPayment }) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);

  useEffect(() => {
    if (!open) {
      setShowConfirmation(false);
      setIsCancelling(false);
    }
  }, [open]);

  const confirmCancellation = async () => {
    if (isCancelling) return;
    setIsCancelling(true);
    await onCancelPayment();
  };

  const paperProps = {
    style: {
      position: 'absolute',
      bottom: 0,
      margin: 0,
      width: '100%',
      maxWidth: '480px',
      borderRadius: '22px 22px 0 0',
      boxShadow: '0 -12px 40px rgba(21,24,43,.22)'
    }
  };

  const secondaryButtonStyle = {
    minHeight: '52px',
    textTransform: 'none',
    fontWeight: 700,
    borderRadius: '12px'
  };

  return (
    <Dialog
      open={open}
      fullWidth
      disableEscapeKeyDown
      disablePortal
      disableAutoFocus
      TransitionComponent={SheetTransition}
      transitionDuration={280}
      PaperProps={paperProps}
      BackdropProps={{ onClick: (event) => event.stopPropagation() }}
    >
      <div className='upi-payment-box'>
        <div className='card-view px-8 py-6'>
          <div style={{ width: '40px', height: '4px', borderRadius: '999px', background: '#d9ddec', margin: '0 auto 20px' }} />
          <div style={{ position: 'relative' }}>
            {!showConfirmation ? (
              <>
                <h4>{title}</h4>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#eef1fb', borderRadius: '12px', padding: '15px', margin: '18px 0' }}>
                  <CircularProgress size={22} thickness={4} />
                  <span style={{ fontWeight: 700 }}>{isCancelling ? 'Checking your final payment status…' : 'Checking payment status…'}</span>
                </div>
                <p style={{ color: '#5b607a', lineHeight: 1.5, margin: '0 0 20px' }}>{isCancelling ? 'Please wait while we confirm whether your payment was completed.' : description}</p>
                {!isCancelling && <Button variant='outlined' color='error' fullWidth size='large' style={secondaryButtonStyle} onClick={() => setShowConfirmation(true)}>Cancel payment</Button>}
              </>
            ) : (
              <>
                <h4>Are you sure you want to cancel the payment?</h4>
                <Button variant='contained' fullWidth size='large' disabled={isCancelling} style={{ ...secondaryButtonStyle, marginTop: '22px', marginBottom: '10px' }} onClick={() => setShowConfirmation(false)}>No, keep waiting</Button>
                <Button variant='outlined' color='error' fullWidth size='large' disabled={isCancelling} style={secondaryButtonStyle} onClick={confirmCancellation}>Yes, cancel payment</Button>
              </>
            )}
            {isCancelling && (
              <div style={{ position: 'absolute', inset: '-12px', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px', background: 'rgba(255,255,255,.42)', backdropFilter: 'blur(3px)', borderRadius: '12px', textAlign: 'center', padding: '24px', color: '#15182b', fontWeight: 700 }}>
                <CircularProgress size={28} thickness={4} />
                <span>Cancellation request received</span>
                <small style={{ color: '#5b607a', fontWeight: 400 }}>Stopping payment-status checks…</small>
              </div>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default IntentPaymentStatusDialog;